import React from 'react';
import {Button, Panel} from 'react-bootstrap';
import {FormattedMessage} from 'react-intl';
import Link from '../../routing/components/Link';

const Result = ({header, body, adds, urls}) => {
  return (
    <div>
      <Panel header={header} className="panel-search">
        <div>
          {body}
        </div>
        {adds}
        <div style={{marginTop: 15}}>
          {urls.map(({url, label}) => {
            return (<Link key={url} url={url}><Button bsStyle="primary" className="btn-sm"><FormattedMessage id="read"/>
              &nbsp;<span style={{textTransform: 'lowercase'}}>{label}</span></Button>
            </Link>);
          })}
        </div>
      </Panel>
    </div>
  );
};

Result.propTypes = {
  header: React.PropTypes.node.isRequired,
  body: React.PropTypes.node.isRequired,
  adds: React.PropTypes.node,
  urls: React.PropTypes.array,
};

Result.defaultProps = {
  adds: [],
  url: []
};

export default Result;



/** WEBPACK FOOTER **
 ** ./src/modules/search/components/Result.js
 **/